import type { CapitalItem } from "../../types";

interface Props {
  item: CapitalItem;
}

const BRAND = "#FF6B35";

export function CapitalItem({ item }: Props) {
  const isIncome = !!item.pm;

  return (
    <div className="bg-white rounded-2xl p-4">
      {/* 第一行：类型 + 金额 */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm font-bold text-gray-900">
            {isIncome ? "收入" : "提现"}
          </span>
          {isIncome && !item.is_closing && (
            <span className="text-xs font-semibold px-1.5 py-0.5 rounded-full" style={{ background: "#FFF1F2", color: "#EF4444" }}>
              未结算
            </span>
          )}
          {!isIncome && item.extract?.status === 0 && (
            <span className="tag-await">待审核</span>
          )}
          {!isIncome && item.extract?.status === 1 && (
            <span className="tag-success">已通过</span>
          )}
          {!isIncome && item.extract?.status === -1 && (
            <span className="tag-fail">已驳回</span>
          )}
        </div>
        <div
          className={`text-sm font-bold ${isIncome ? "text-green-600" : "text-red-500"}`}
        >
          <span>{isIncome ? "+" : "-"}</span>
          ¥{item.number}
        </div>
      </div>

      {/* 第二行 */}
      <div className="flex items-center justify-between mt-3 text-xs text-gray-500">
        {isIncome ? (
          <> {item.link_id ? `订单号: ${item.order?.ordersn || ""}` : `资金标题: ${item.title || ""}`} </>
        ) : (
          <>提现方式: {item.extract?.extract_type || ""}</>
        )}
        <span>余额: ¥{item.balance}</span>
      </div>

      {/* 第三行 */}
      <div className="mt-2 text-xs text-gray-400">
        {isIncome ? (
          item.link_id ? (`服务时间: ${item.order?.book_time || ""}`) : (`资金内容: ${item.mark || ""}`)
        ) : (
          `提现时间: ${item.add_time || ""}`
        )}
      </div>

      {/* 驳回原因 */}
      {(item.extract?.status ?? 0) < 0 && (
        <div className="mt-3 pt-3 border-t border-red-50 flex gap-1.5 text-xs text-gray-500">
          <span>驳回原因:</span>
          <span className="line-clamp-2">{item.extract?.fail_msg || ""}</span>
        </div>
      )}

      <style>{`
        .tag-await { display:inline-block; line-height:18px; padding:0 8px; border-radius:6px; font-size:11px; font-weight:600; color:#F59E0B; background:#FFFBEB; }
        .tag-success { display:inline-block; line-height:18px; padding:0 8px; border-radius:6px; font-size:11px; font-weight:600; color:#10B981; background:#EDFCF5; }
        .tag-fail { display:inline-block; line-height:18px; padding:0 8px; border-radius:6px; font-size:11px; font-weight:600; color:#EF4444; background:#FFF1F2; }
      `}</style>
    </div>
  );
}
